var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-form table-responsive" }, [
    _c("table", { staticClass: "table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.paymentView.agencyPaymentViewRows, function (row) {
            return _c("tr", { key: row.id }, [
              _c("th", { staticStyle: { padding: "0px !important" } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("ddMMyyyyHHmm")(row.date)) +
                    "\n"
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticStyle: { padding: "0px !important" } }, [
                row.type == "expense"
                  ? _c("div", [
                      _c(
                        "span",
                        {
                          staticClass: "clickable-text",
                          staticStyle: { "font-weight": "normal" },
                          on: {
                            click: function ($event) {
                              return _vm.goToReference(row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(row.description) + " ")]
                      ),
                      _vm._v(" / "),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("toCurrency")(row.amount))),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("th", { staticStyle: { padding: "0px !important" } }, [
                row.type == "info"
                  ? _c("div", [
                      _c(
                        "span",
                        {
                          staticClass: "clickable-text",
                          staticStyle: { "font-weight": "normal" },
                          on: {
                            click: function ($event) {
                              return _vm.goToReference(row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(row.description) + " ")]
                      ),
                      _vm._v(" / "),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("toCurrency")(row.amount))),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("th", { staticStyle: { padding: "0px !important" } }, [
                row.type == "income"
                  ? _c("div", [
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v(_vm._s(row.description) + " "),
                      ]),
                      _vm._v(" / "),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("toCurrency")(row.amount))),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ])
          }),
          _vm._v(" "),
          _c("tr", { staticStyle: { "margin-top": "10px" } }, [
            _c("th", { staticStyle: { padding: "0px !important" } }),
            _vm._v(" "),
            _c("th", { staticStyle: { padding: "0px !important" } }, [
              _vm._v(
                "\n         Alacak Toplam : " +
                  _vm._s(_vm._f("toCurrency")(_vm.paymentView.expense)) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { padding: "0px !important" } }, [
              _vm._v(
                "\n          Bakiye : " +
                  _vm._s(_vm._f("toCurrency")(_vm.paymentView.balance)) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { padding: "0px !important" } }, [
              _vm._v(
                "\n          Borç Toplam : " +
                  _vm._s(_vm._f("toCurrency")(_vm.paymentView.income)) +
                  "\n        "
              ),
            ]),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Tarih")]),
        _vm._v(" "),
        _c("th", [_vm._v("Alacak")]),
        _vm._v(" "),
        _c("th", [_vm._v("Bilgi")]),
        _vm._v(" "),
        _c("th", [_vm._v("Borç")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }